import { render, staticRenderFns } from "./TalentPlan.vue?vue&type=template&id=1dd82eae&scoped=true"
import script from "./TalentPlan.vue?vue&type=script&lang=js"
export * from "./TalentPlan.vue?vue&type=script&lang=js"
import style0 from "./TalentPlan.vue?vue&type=style&index=0&id=1dd82eae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.109.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd82eae",
  null
  
)

export default component.exports